module.exports = "## Apply photo filters with ease\r\n\r\nSometimes your photos need an extra boost to bring out the colors and add that wow factor. Our photo editor allows you to add a variety of preconfigured filters to bring out the best in your photos. \r\n\r\nWhether you are looking to give your photo a Retro or a Light leak look, we have got your covered with more than 15 photo filters."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-section-one.md
// module id = 1169
// module chunks = 0